"use client";
import { jsx } from "react/jsx-runtime";
import { cn } from "../../utils/cn.js";
import { ScrollArea } from "../ScrollArea/index.js";
function PopoverBody({ children, className }) {
    return /*#__PURE__*/ jsx(ScrollArea, {
        popoverBody: true,
        className: cn('flex-1', className),
        children: children
    });
}
export { PopoverBody };
